﻿import $ from "jquery";
import ko from "knockout";

import TabModel from "./TabModel";

export default class RootModel {
	constructor(model, options) {
		const _ = this;

		_.categories = model;
		_.options = options;

		_.tabs = {};
		_.activeTab = ko.observable();

		_.goToTab(_.categories[0], null, true);

		const $ep = $(`#${options.entryPointId}`);
		$ep.on("ccsResize", () => _.activeTab().updatePageSize());

		$(document)
			.on("click", function (e) {
				if ($(e.target).closest(".ccs-logo-search").length === 1) {
					return;
				}

				$ep.find(".ccs-logo-subcategories").slideUp();
				_.activeTab().dropdownVisible(false);

			})
			.on("ccs.logo-shown", function (e, eventInfo) {
				if (eventInfo.entryId === $(`#${options.entryPointId}`).closest(".ccs-logo-ls-popup").attr("id")) {
					_.activeTab().parsePrices();
				}
			});

		if (!ko.bindingHandlers.upSellsProductField) {
			ko.bindingHandlers.upSellsProductField = {
				init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
					const fieldName = bindingContext.field.name;

					const $el = $(element);

					if (fieldName === "color" && viewModel.category === 0 && viewModel.info[fieldName] !== undefined) {
						const colorDots = viewModel.info[fieldName].split(";");
						let result = "";
						ko.utils.arrayForEach(colorDots, color => {
							const attr = color.trim().toLowerCase();

							if (attr === "tri-color") {
								result += `<span data-color="${attr}">${color}&nbsp;</span>`;
							} else {
								result += `<span data-color="${attr}">${color}&nbsp;<span class="color-dot"></span></span>`;
							}
						});

						$el.html(result);

						return;
					}

					$el.html(viewModel.info[fieldName] || options.texts.notAvailable);
				}
			};
		}
	}

	goToTab(category, e, firstRun) {
		const _ = this, options = _.options;

		const tabs = _.tabs;
		if (!tabs[category.id]) {
			tabs[category.id] = new TabModel(category, options, firstRun);
		}

		_.activeTab(tabs[category.id]);

		if (options.inline) {
			_.activeTab().updatePageSize();
		}

		if (!firstRun) {
			ccs_cc_log.dispatchEvent(category.clickEvent);
		}
	}

	isActiveTab(id) {
		return id === this.activeTab().id;
	}
}
